import { buildDailyLogPdf, loadImageDataUrl } from './dailyLogPdf';
import { cell, type DailyLogData } from '../components/DailyLogDoc';
import { fmtDMY } from './format';

/** Build the daily-log PDF and share it (mobile) or download it (desktop). */
export async function shareDailyLogPdf(data: DailyLogData, equipmentId: string): Promise<'shared' | 'downloaded'> {
  const eq = data.equipment as { name?: string; location?: string } | null;
  const logoDataUrl = await loadImageDataUrl('/logo.png');

  const blob = await buildDailyLogPdf({
    org: data.org,
    logoDataUrl,
    title: (data.template as { title?: string })?.title ?? 'Reading Log',
    equipName: eq?.name ?? equipmentId,
    equipLoc: eq?.location ?? '',
    equipmentId,
    date: data.date,
    sections: (data.template?.sections ?? []).map((s) => ({
      label: s.label,
      fields: s.fields.map((f) => ({ key: f.key, label: f.label, unit: f.unit })),
    })),
    rows: (data.rows ?? []) as Array<Record<string, unknown>>,
    cell,
  });

  const fileName = `Daily-Log_${equipmentId}_${fmtDMY(data.date)}.pdf`;
  const file = new File([blob], fileName, { type: 'application/pdf' });
  const nav = navigator as Navigator & { canShare?: (d: ShareData) => boolean };

  if (nav.canShare && nav.canShare({ files: [file] })) {
    await nav.share({ files: [file], title: `Daily Log — ${eq?.name ?? equipmentId} — ${data.date}` });
    return 'shared';
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = fileName; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
  return 'downloaded';
}
